import AppSwitcher from './AppSwitcher';

export default AppSwitcher;
